import {AppState} from '@app/context/context';
import {ordersColumnsStorage} from '@app/storage/ordersColumnsStorage';
import React from "react";

export interface UpdateOrdersConfigEvent {
    config: Partial<AppState['orders']['config']>;
}

export function emitOrdersConfigUpdate(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: UpdateOrdersConfigEvent & {isSavedConfig?: boolean}
) {
    setState((prevState: AppState) => {
        const updatedConfig = {
            ...prevState.orders.config,
            ...event.config
        };

        if (event.isSavedConfig) {
            ordersColumnsStorage.set(updatedConfig);
        }

        return {
            ...prevState,
            orders: {
                ...prevState.orders,
                config: updatedConfig
            }
        };
    });
}
